import type { IImage } from "@components/types/media";

import { Heading } from "@components/core/Heading";
import { Image } from "@components/core/Image";
import { cn } from "@ui/lib/utils";

import type { ICard, ICardAsset, ICardAvatar, ICardLink } from "./Card";

import LazyVideoPlayer from "../core/LazyVideoPlayer";
import { CardAvatar } from "./Card";
import { CardAsset } from "./Card";
import { CardLink } from "./Card";
import { Card } from "./Card";

export interface CardCommunityAssetProps extends ICard, ICardAsset, ICardAvatar, ICardLink {
  cardAssetClassName?: string;
  img?: IImage;
  title?: string;
  videoUrl?: null | string;
}

const CardCommunityAsset = ({
  img,
  label,
  avatar,
  className,
  cardAssetClassName,
  name,
  href,
  title,
  ratio = "16x9",
  videoUrl,
  ...props
}: CardCommunityAssetProps) => {
  const Asset = videoUrl ? (
    <LazyVideoPlayer
      cover={img}
      ratio={ratio === "responsive" || ratio === "responsiveMD" ? "16x9" : ratio}
      src={videoUrl}
    />
  ) : (
    img && <Image {...img} />
  );
  return (
    <Card {...props} className={cn("card-community-asset group before:-bottom-12", className)} withLink={!!href}>
      <CardAsset
        asset={Asset}
        className={cn("relative", cardAssetClassName)}
        hoverEffect={!!href}
        label={label}
        ratio={ratio}
      >
        {(href || title) && (
          <div
            className={cn(
              "absolute inset-0 z-1 flex items-end overflow-hidden rounded-xl p-20 text-inverse",
              'before:e-gradient-b-gray before:absolute before:inset-0 before:opacity-60 before:content-[""]',
            )}
          >
            {href?.length ? (
              <CardLink href={href}>
                <Heading className='f-subhead-02 relative z-1 line-clamp-3' level={3}>
                  {title}
                </Heading>
              </CardLink>
            ) : (
              <Heading className='f-subhead-02 relative z-1 line-clamp-3' level={3}>
                {title}
              </Heading>
            )}
          </div>
        )}
      </CardAsset>
      <CardAvatar avatar={avatar} className='mt-12' name={name} />
    </Card>
  );
};

CardCommunityAsset.displayName = "CardCommunityAsset";

export { CardCommunityAsset };
export default CardCommunityAsset;
